import { Injectable } from '@angular/core';
import { DetailedEntityDataService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { SearchStatus } from '../../../../shared/search/models/search-status.model';
import { ReportConfigurationSearchService } from './reports-configuration-search.service';

@Injectable()
export class ReportsConfigurationDataService extends DetailedEntityDataService {

    constructor(protected coreServiceRegistry: CoreServiceRegistry,
        protected sharedServiceRegistry: SharedServiceRegistry) {
        super(coreServiceRegistry, sharedServiceRegistry);
    }

    public initializeDetailsSearchContext() {
        this.detailsSearchParams = this.entityConfig.getDetailSearchParams();
        this.detailsSearchParams.defaultSearchColumn = '';
        this.detailsSearchParams.tableEditor = this.dataEditor;
        this.detailsSearchParams.alertService = this.alertService;
        if (this.buttonService) {
            this.detailsSearchParams.actionButtons = this.buttonService.getButtonsForPanel('detail-table');
        }
        this.detailsSearchStatus = new SearchStatus();

        const searchService: ReportConfigurationSearchService = new ReportConfigurationSearchService(this.coreServiceRegistry, this.sharedServiceRegistry,
            this.detailsSearchParams, this.detailsSearchStatus);
        searchService.setDataService(this);
        this.detailsSearchService = searchService;
        // LFWM-1965 Fixes - overriding printType metadata to display it in ['Key - Value'] format
        // LFWM - 2709 - display value from metadata which is in key value format
        // this.detailsSearchService.fetchMetadata().subscribe(metadata => {
        //     metadata.columnList.forEach(columnMetadata => {
        //         if (columnMetadata.propertyName === 'printType') {
        //             columnMetadata.values.forEach((option: any) => {
        //                 if (option.value !== '- Select -') {
        //                     option.value = option.key + ' - ' + option.value;
        //                 }
        //             });
        //         }
        //     });
        // });

    }

    // overridden method - needs to populate report id value when adding new line item
    public handleAddNewLineItem(event: any) {
        event.selectedRow.cells['reportId'].cVal = this.primaryDataMap[this.primarySearchParams.idProperty].cVal;
        super.handleAddNewLineItem(event);
    }

    /** returns all the line items of the entity
     * overriding this function from the parent because
     * no need to append primary id property in the lineitems.
     * since primaryProperty reportId is already present as a hidden field in table.
    **/
    public getAllLineItems(primaryProperties: any, searchService?: any) {
        const allRows = this.detailsSearchService.getPagedData().pageRows;
        if (allRows.length === 0) {
            return allRows;
        }
        const allLineItems = [];
        allRows.forEach((lineItemRow: any, index: number) => {
            const lineItem = [];
            const lineItemCells = lineItemRow.cells;
            const lineItemProperties = Object.keys(lineItemCells);
            lineItemProperties.forEach((lineItemProperty: any) => {
                lineItem.push({ cName: lineItemProperty, cVal: lineItemCells[lineItemProperty].cVal });
            });
            allLineItems.push({ rIdx: index, cells: lineItem });
        });
        return allLineItems;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-configuration/services/reports-configuration-data.service.ts